import { Edit03 } from '@/icons'
import { Input, useModal } from '@dashboard/ui'
import { SelectStoreItemModal } from '@/layouts/components/InputStoreItem/SelectStoreItemModal'
import { useStoreItemByIdsQuery } from '@/layouts/components/InputStoreItem/useStoreItemByIdsQuery'
import { useGenerateCompanyPath } from '@/libs'
import { DEFAULT_IMAGE_PLACEHOLDER_ITEM } from '@/Settings'

export interface InputStoreItemProps {
  onChange: (value: string | undefined) => void
  value: string | undefined
}

export const InputStoreItem = (props: InputStoreItemProps) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { data: storeItems } = useStoreItemByIdsQuery(companyId, gameId, props.value ? [props.value] : [])

  const openEditModal = useModal<{
    onChange: (value: string | undefined) => void
    value: string | undefined
  }>(p => <SelectStoreItemModal {...p} />)

  return (
    <Input
      value={storeItems?.[0]?.item.name}
      onChange={() => {
        //do nothing
      }}
      extraLeft={{
        width: 32,
        icon: () => (
          <div
            className="size-[28px] shrink-0 rounded-md bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${storeItems?.[0]?.item?.image_url || DEFAULT_IMAGE_PLACEHOLDER_ITEM})`,
            }}
          />
        ),
      }}
      extraRight={{
        pointer: true,
        icon: (
          <div
            className="flex h-full cursor-pointer items-center justify-center"
            style={{ zIndex: 1 }}
            onClick={() => openEditModal({ value: props.value, onChange: props.onChange })}
          >
            <Edit03 />
          </div>
        ),
      }}
    />
  )
}
